import { yupBoolean, yupObject, yupString } from '../../yup';

/**
 * Validation schema for the ERHL "financial obligations" declaration
 * shown on the Assets & Liabilities step.
 */
export const erhlFinancialObligationsSchema = yupObject({
  hasFinancialObligations: yupBoolean().required().label('This question'),
  financialObligationsDescription: yupString()
    .when('hasFinancialObligations', {
      is: true,
      then: (schema) => schema.required('Please describe these obligations'),
    })
    .label('Financial obligations description'),
});
